import React from 'react';
import SelectTree from '../SelectTree';
const SelectAutomation = ({ automationTree, onAutomationChange, onAutomationClose, }) => (React.createElement(SelectTree, { tree: automationTree, selectProps: { minWidth: 50 }, treeRef: "symbol", onClose: onAutomationClose, onChange: onAutomationChange }));
export default SelectAutomation;
